import { useMemo } from 'react'
import { useTrackChanges } from './hooks'
import { savedKvps } from './storage'
import { Plus, Trash2 } from 'lucide-react'
import CustomButton from 'src/components/Shared/UIComponents/Button'
import InputField from 'src/components/Shared/UIComponents/InputField'

type Props = {
  initialValue: Record<string, string>
}

export default function Kvps(props: Props) {
  const initialValue = useMemo(
    () =>
      Object.keys(props.initialValue)
        .sort()
        .map((key) => props.initialValue[key]),
    [props.initialValue],
  )

  const [kvps, setKvps] = savedKvps.useState(initialValue)
  useTrackChanges('application.kvps', initialValue, kvps, setKvps)

  return (
    <>
      {kvps.map((item, index) => (
        <div
          key={'kvp' + index}
          className="flex items-start gap-4 group items-end"
        >
          <InputField
            label={'kvp' + (index + 1)}
            value={item}
            type="text"
            setValue={(value: any) =>
              setKvps((prev) =>
                prev.map((prevItem, prevIndex) =>
                  prevIndex === index ? value : prevItem,
                ),
              )
            }
          />
          <CustomButton
            label="delete"
            iconPosition="left"
            icon={<Trash2 size={18} className="text-primary-foreground" />}
            onClick={() =>
              setKvps((prev) => [
                ...prev.slice(0, index),
                ...prev.slice(index + 1),
              ])
            }
          />
        </div>
      ))}

      <div className="flex items-start gap-4 group items-end">
        <CustomButton
          label="Add new kvp"
          iconPosition="left"
          onClick={() => setKvps((prev) => [...prev, ''])}
          icon={<Plus size={18} className="text-primary-foreground" />}
        />
      </div>
    </>
  )
}
